(function(algolia) {
  'use strict';

  var enabled = algolia.config.analytics_enabled;
  if (!enabled) return;
  
  function setCookieConsentCheckInterval(callback, delay, iterations) {
    let i = 0;
    let intervalID = window.setInterval(function () {
      if (i >= iterations) {
        // if cookie consent check failed, initialize algolia with useCookie: false
        algoliaInit(false);
        window.clearInterval(intervalID);
        return;
      }
      callback(intervalID);
      i++;
    }, delay);
  }

  /**
   * Check cookie consent before initializing Algolia Search Insights.
   */
  if (typeof window.CookieInformation !== 'undefined') {
    let cookieConsent = (CookieInformation.getConsentGivenFor('cookie_cat_marketing') == true) ? true : false;
    algoliaInit(cookieConsent);
  } else {
    setCookieConsentCheckInterval(function (intervalID) {
      if (typeof window.CookieInformation !== 'undefined') {
        let cookieConsent = (CookieInformation.getConsentGivenFor('cookie_cat_marketing') == true) ? true : false;
        algoliaInit(cookieConsent);
        window.clearInterval(intervalID);
      }
    }, 400, 3);
  }
  
  /**
   * Algolia Insights generates and saves a random userToken for
   * each user in a first-party cookie named _ALGOLIA.
   *
   * Since v2, search-insights doesn’t generate and store anonymous
   * user token in the _ALGOLIA cookie by default. _ALGOLIA cookie
   * is enabled by setting useCookie option to true.
   *
   * We use cookieDuration option to set custom expiration time
   * for the cookie.
   *
   * More info: https://www.algolia.com/doc/guides/sending-events/implementing/best-practices/usertoken/
   */

  function algoliaInit(cookieConsent) {
    window.aa('init', {
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      useCookie: cookieConsent,
      cookieDuration: 60 * 60 * 1000 * 24 * 30 * 12 // 1 year (default is 6 months)
    });
  }
  
  const instantsearch = window.algoliaShopify.instantsearch;
  
  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      // Changing the event to 'convert' from 'click'
      conversionData.eventName = 'convert';
      // Removing the `positions` property
      delete conversionData.positions;

      // Add the current products data to local storage
      previousClickItems.push(conversionData)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  };

  /**
   * Get user token from _ALGOLIA cookie.
   * 
   * 'anonymous-' prefix is removed from the default token value. 
   */
  algolia.getAlgoliaUserToken = function () {
    let algoliaUserToken = null;
    window.aa('getUserToken', null, (err, userToken) => {
      if (err) {
        console.error(err);
        return;
      }
      if (typeof userToken === 'string' || userToken instanceof String) {
        algoliaUserToken = userToken.replace('anonymous-', '');
      }
    });
    return algoliaUserToken;
  };

  /**
   * Search product by SKU and retrieve its object id.
   */
  algolia.getProductObjectIdBySku = function (sku) {
    return Promise.resolve(sku).then((sku) => {
      const client = algolia.externals.algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      );
      let filters = 'named_tags.ISBN:' + sku;
      return client.searchForHits({
        requests: [{
          indexName: 'shopify_test_products',
          query: sku,
          filters: filters
        }]
      }).then(({ results: [{ hits }] }) => {
        let objectId = null;
        if (hits.length > 0) {
          let len = hits.length;
          for (let i = 0; i < len; i++) {
            let hit = hits[i];
            if (hit.sku === sku) {
              objectId = hit.objectID;
              break;
            }
          }
        }
        return objectId;
      });
    });
  };

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion(e) {
    try {
      if (algolia.config.analytics_enabled) {
        sendAddToCartConversionEvent(e.target);
      }

      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey)
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString)
        previousClickItems.forEach((data) => {
          window.aa('convertedObjectIDsAfterSearch', data);
        })
      }
    } catch (error) {
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  function sendAddToCartConversionEvent(submitEl) {
    const hitEl = submitEl.closest('.ais-hit');

    if (typeof(hitEl) == 'undefined' || hitEl == null) {
      return;
    }

    let objectId = hitEl.dataset.algoliaObjectid,
        queryId = hitEl.dataset.algoliaQueryid;

    if (!objectId || !queryId) {
      return;
    }

    let token = algolia.getAlgoliaUserToken();
    if (token) {
      let data = {
        userToken: token,
        index: 'shopify_test_products',
        eventName: 'PSP;Product added to cart',
        queryID: queryId,
        objectIDs: [objectId]
      };

      // Send the conversion event
      window.aa('convertedObjectIDsAfterSearch', data);
    }
  }

  if (instantsearch) {
    /**
     * When search results are rendered,
     * attach click event listeners to add-to-cart buttons.
     */
    instantsearch.search.on('render', () => {
      // Track a conversion event when clicking the 'add to cart' button.
      const addToCartBtns = document.querySelectorAll('.ais-hit--cart .add-to-cart');
      if (addToCartBtns.length > 0) {
        for (var i = 0; i < addToCartBtns.length; i++) {
          addToCartBtns[i].addEventListener('click', trackConversion);
        }
      }
    });
  }
})(window.algoliaShopify);